// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".user-address[data-v-7e7142b6]{border:1px solid var(--bs-primary)}", "",{"version":3,"sources":["webpack://./resources/js/components/ecommerece/UserAddress.vue"],"names":[],"mappings":"AACA,+BACI,kCAAJ","sourcesContent":["\n.user-address {\n    border: 1px solid var(--bs-primary);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
